import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Renderer2,
} from '@angular/core';
import { PermissionStore } from '@core/store/permission.store';
import { LocalService } from '@core/services/local.service';

@Directive({
  standalone: false,
  selector: '[appFieldPermission]',
})
export class CustomFieldPermissionDirective implements AfterViewInit {
  @Input() appFieldPermission!: string;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private permissionStore: PermissionStore,
    private sessionStorage: LocalService
  ) {
      // do nothing.
  }

  ngAfterViewInit() {
    const assetAccess = this.permissionStore.state['assetAccess'];
    const pageAccess = this.permissionStore.state['pageAccess'];

    if (pageAccess && assetAccess) {
      const isAddMode = this.sessionStorage.getItem('gridAction') === 'add';
      const isEditMode = this.sessionStorage.getItem('gridAction') === 'edit';

      const fieldPermission = assetAccess.find(
        (field: any) => field.key === this.appFieldPermission
      );

      if (fieldPermission) {
        this.setVisibility(fieldPermission.hide);
        this.setDisabledState(fieldPermission, isAddMode, isEditMode);
      }
    }
  }

  private setVisibility(hide: boolean) {
    if (hide) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
    } else {
      this.renderer.removeStyle(this.elementRef.nativeElement, 'display');
    }
  }

  private setDisabledState(
    fieldPermission: any,
    isAddMode: boolean,
    isEditMode: boolean
  ) {
    if ((!fieldPermission.c && isAddMode) || (!fieldPermission.u && isEditMode)) {
      const template = this.elementRef.nativeElement;

      if (template.tagName === 'A') {
        this.renderer.setAttribute(template, 'href', 'javascript:void(0);');
        this.renderer.setAttribute(template, 'disabled', 'true');
      } else if (
        ['P-MULTISELECT', 'P-DROPDOWN', 'P-CHECKBOX', 'P-TREESELECT', 'P-RADIOBUTTON', 'P-CALENDAR'].includes(
          template.tagName
        )
      ) {
        this.renderer.addClass(template, 'p-disabled');
      } else {
        this.renderer.setProperty(template, 'disabled', true);

        // Disable specific child nodes and events
        const childInputNodes = this.elementRef.nativeElement.querySelectorAll(
          'input, select, textarea, button, a, ng-select, div, label'
        );
        childInputNodes.forEach((elem: any) => {
          this.renderer.setAttribute(elem, 'disabled', 'true');
          this.renderer.setStyle(elem, 'pointer-events', 'none');
        });

        // Disable drag and drop functionality
        if (template.hasAttribute('(ngxf-drop)') || template.hasAttribute('(ngxf-select)')) {
          this.renderer.setStyle(template, 'pointer-events', 'none');
          this.renderer.setProperty(template, 'onclick', null);
        }
      }
    }
  }
}
